import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#more-icons" }),
  /*#__PURE__*/_createTextVNode(" More icons ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " You can use different icons to distinguish different rate components. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "icon-rate-face-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_rate = _resolveComponent("el-rate")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_el_rate, {
        modelValue: _ctx.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.value = $event)),
        "icon-classes": _ctx.iconClasses,
        "void-icon-class": "el-icon-remove-outline",
        colors: ['#99A9BF', '#F7BA2A', '#FF9900']
      }, null, 8, ["modelValue", "icon-classes"]),
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code4), 1)
        ]),
        _: 1
      })
    ])
  ]))
}